import APIService from "./APIService";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { useTranslation } from "react-i18next";
import i18n from "i18next";

import ServiceClassPicker from "./ServiceClassPicker";
import TimberMaterialPicker from "./TimberMaterialPicker";
import ScrewPicker from "./ScrewPicker";
import CodePicker from "./CodePicker";

export default function RinforzoTrave(props) {
  const ServiceClassRef = useRef(null);
  const CodeRef = useRef(null);
  const TimberMaterialRefMain = useRef(null);
  const TimberMaterialRefSec = useRef(null);
  const ScrewPickerRef = useRef(null);

  const [CreateReport, SetCreateReport] = useState("");
  const [Ratio, setRatio] = useState("");
  const [validData, setValidData] = useState(true);
  const [resultMessages, setResultMessages] = useState("");
  const [LoadDuration, SetLoadDuration] = useState("1");
  const [isKmodDisabled, setKmodDisabled] = useState(true);
  const [ImageRinforzo, setImageRinforzo] = useState("Rinforzo/Rinforzo_1.png");
  const [nMax, setNMax] = useState(4);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const getRatio = () => {
    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    var loadduration = parseInt(LoadDuration);
    var code = parseInt(CodeRef.current.getData());
    var G1k = parseFloat(getValues("HookG1k"));
    var G2k = parseFloat(getValues("HookG2k"));
    var Qk = parseFloat(getValues("HookQ1k"));

    const existingBeamB = parseFloat(getValues("HookMainB"));
    const existingBeamH = parseFloat(getValues("HookMainH"));
    var existingBeamMaterial = parseInt(TimberMaterialRefMain.current.getData());
    var existingBeamLength = parseFloat(getValues("HookL"));
    var existingBeamDistance = parseFloat(getValues("HookD"));

    var u0max = parseFloat(getValues("HookUMax0"));
    var u1max = parseFloat(getValues("HookUMax1"));

    const addedBeamB = parseFloat(getValues("HookSecB"));
    const addedBeamH = parseFloat(getValues("HookSecH"));
    var addedBeamMaterialName = parseInt(TimberMaterialRefSec.current.getData());

    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    const centerSpacing = parseInt(getValues("HookSc"));
    const spacingAtSupport = parseInt(getValues("HookSa"));
    const screwAngle = parseFloat(getValues("HookScrewAngle"));
    const screwNumber = parseFloat(getValues("HookNx"));

    const flooringThickness = parseFloat(getValues("HookAssito"));

    var kmod = 0.0;
    const language = i18n.language;

    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_BEAMSTIFFENING_RATIO;

    const promiseResult = APIService.GetRatio(
      {
        ServiceClass,
        loadduration,
        existingBeamB,
        existingBeamH,
        existingBeamMaterial,
        existingBeamLength,
        existingBeamDistance,
        addedBeamB,
        addedBeamH,
        addedBeamMaterialName,
        ScrewType,
        centerSpacing,
        spacingAtSupport,
        screwAngle,
        G1k,
        G2k,
        Qk,
        CreateReport,
        language,
        kmod,
        email,
        flooringThickness,
        screwNumber,
        code,
        u0max,
        u1max
      },
      address
    );
    promiseResult.then((value) => {
      console.log(value);
      setRatio(value["ratio"]);
      setResultMessages(value["result"]);
      setValidData(value["valid"]);
    });
  };

  const getReport = () => {
    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    var loadduration = parseInt(LoadDuration);
    var code = parseInt(CodeRef.current.getData());
    var G1k = parseFloat(getValues("HookG1k"));
    var G2k = parseFloat(getValues("HookG2k"));
    var Qk = parseFloat(getValues("HookQ1k"));

    const existingBeamB = parseFloat(getValues("HookMainB"));
    const existingBeamH = parseFloat(getValues("HookMainH"));
    var existingBeamMaterial = parseInt(TimberMaterialRefMain.current.getData());
    var existingBeamLength = parseFloat(getValues("HookL"));
    var existingBeamDistance = parseFloat(getValues("HookD"));

    var u0max = parseFloat(getValues("HookUMax0"));
    var u1max = parseFloat(getValues("HookUMax1"));

    const addedBeamB = parseFloat(getValues("HookSecB"));
    const addedBeamH = parseFloat(getValues("HookSecH"));
    var addedBeamMaterialName = parseInt(TimberMaterialRefSec.current.getData());

    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    const centerSpacing = parseInt(getValues("HookSc"));
    const spacingAtSupport = parseInt(getValues("HookSa"));
    const screwAngle = parseFloat(getValues("HookScrewAngle"));

    const flooringThickness = parseFloat(getValues("HookAssito"));
    const screwNumber = parseFloat(getValues("HookNx"));

    var kmod = 0.0;
    const language = i18n.language;

    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_BEAMSTIFFENING_REPORT;

    const promiseResult = APIService.GetReportComplete(
      {
        ServiceClass,
        loadduration,
        existingBeamB,
        existingBeamH,
        existingBeamMaterial,
        existingBeamLength,
        existingBeamDistance,
        addedBeamB,
        addedBeamH,
        addedBeamMaterialName,
        ScrewType,
        centerSpacing,
        spacingAtSupport,
        screwAngle,
        G1k,
        G2k,
        Qk,
        CreateReport,
        language,
        kmod,
        email,
        flooringThickness,
        screwNumber,
        code,
        u0max,
        u1max
      },
      address
    );
    promiseResult.then((response) => console.log("downloaded")).catch((error) => console.log("error", error));
    setRatio("");
    setResultMessages("");
    setValidData("");
  };

  const onErrors = (errors) => console.error(errors);

  const onSubmit = (event) => {
    if (CreateReport === 0) {
      getRatio();
    } else if (CreateReport === 1) {
      getReport();
    }
  };

  const { t } = useTranslation();

  const onChangeLoadDuration = (event) => {
    const value = event.target.value;
    SetLoadDuration(value);
    if (value === "0") {
      setKmodDisabled(false);
    } else {
      setKmodDisabled(true);
    }
  };

  function handleChangeB(e) {
    var mainB = parseFloat(getValues("HookMainB"));
    var secB = parseFloat(getValues("HookSecB"));
    var minB = Math.min(mainB, secB);
    var i = 0;
    if (minB > 0){
      setNMax(Math.round(minB / 40));
    }
    if (i <= 0){
      i = 1;
    }
  }

  function handleChange(e) {
    const currentH1 = parseFloat(getValues("HookMainH"));
    const currentHa = parseFloat(getValues("HookAssito"));
    const currentH2 = parseFloat(getValues("HookSecH"));
    ScrewPickerRef.current.setMinL((currentH1 + currentHa + 30) / Math.cos(3.14 / 4.0));
    ScrewPickerRef.current.setMaxL((currentH1 + currentHa + currentH2) / Math.cos(3.14 / 4.0));
  }

  function updateImage(e) {
    const currentNx = parseInt(getValues("HookNx"));
    const currentHa = parseInt(getValues("HookAssito"));
    if (currentHa <= 0.0) {
      if (currentNx === 1) {
        setImageRinforzo("Rinforzo/Rinforzo_1.png");
      } else if (currentNx === 2) {
        setImageRinforzo("Rinforzo/Rinforzo_2.png");
      } else {
        setImageRinforzo("Rinforzo/Rinforzo_3.png");
      }
    } else {
      if (currentNx === 1) {
        setImageRinforzo("Rinforzo/Rinforzo_10.png");
      } else if (currentNx === 2) {
        setImageRinforzo("Rinforzo/Rinforzo_8.png");
      } else {
        setImageRinforzo("Rinforzo/Rinforzo_9.png");
      }
    }
  }

  return (
    <form className="max-w-fit" onSubmit={handleSubmit(onSubmit, onErrors)}>
      <div className="flex flex-wrap -mx-2 mb-5">
        <div className="form-col1_3">
          <TransformWrapper>
            <TransformComponent>
              <img src={ImageRinforzo} alt="" />
            </TransformComponent>
          </TransformWrapper>
        </div>
        <div className="form-col1_3"></div>
        <div className="form-col1_3"></div>

        <div className="form-col1_6">
          <CodePicker ref={CodeRef}></CodePicker>
        </div>

        <ServiceClassPicker ref={ServiceClassRef} />
        <div className="form-col1_6">
          <label className="form-label" for="grid-LoadDuration">
            {t("LoadDuration")}
          </label>
          <select className="form-select" id="grid-LoadDuration" name="grid-LoadDuration" onChange={onChangeLoadDuration} defaultValue={LoadDuration}>
            <option value="1">{t("Permanente")}</option>
            <option value="2">{t("Lunga")}</option>
            <option value="3">{t("Media")}</option>
            <option value="4">{t("Breve")}</option>
            <option value="5">{t("Istantanea")}</option>
            <option value="0">{t("Manual")}</option>
          </select>
        </div>
        {isKmodDisabled ? (
          <div />
        ) : (
          <div className="form-col1_6">
            <label className="form-label" for="grid-kmod">
              {t("Kmod")}
            </label>
            <input
              className="form-input"
              id="grid-kmod"
              type="number"
              step={0.01}
              placeholder={t("Kmod")}
              defaultValue={1}
              readOnly={isKmodDisabled}
              {...register("HookKmod", {
                required: t("Required"),
                min: {
                  value: 0.01,
                  message: t("Minimo") + " 0.01",
                },
                max: {
                  value: 10,
                  message: t("Massimo") + " 10",
                },
              })}
            ></input>
            <p className="form-error">{errors.HookKmod?.message}</p>
          </div>
        )}
        <div className="form-col1_6" />
        {isKmodDisabled ? <div className="form-col1_3" /> : <div className="form-col1_6" />}

        <div className="form-col1_6">
          <label className="form-label" for="grid-shear">
            G<sub>1k</sub> [kN/m<sup>2</sup>]
          </label>
          <input
            className="form-input"
            id="grid-g1k"
            type="number"
            step={0.01}
            defaultValue={1}
            placeholder="G1k"
            {...register("HookG1k", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p className="form-error">{errors.HookG1k?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-g2k">
            G<sub>2k</sub> [kN/m<sup>2</sup>]
          </label>
          <input
            className="form-input"
            id="grid-g2k"
            type="number"
            step={0.01}
            defaultValue={2}
            placeholder="G2k"
            {...register("HookG2k", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p className="form-error">{errors.HookG2k?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-q1k">
            Q<sub>1k</sub> [kN/m<sup>2</sup>]
          </label>
          <input
            className="form-input"
            id="grid-q1k"
            type="number"
            step={0.01}
            defaultValue={2}
            placeholder="Q1k"
            {...register("HookQ1k", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p className="form-error">{errors.HookQ1k?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-q1k">
            L / U<sub>max,t0</sub>
          </label>
          <input
            class="form-input"
            id="grid-umaxto"
            type="number"
            step={0.1}
            defaultValue={300}
            placeholder="L/Umax,t0"
            {...register("HookUMax0", {
              required: t("Required"),
              min: {
                value: 10,
                message: t("Minimo") + " 10",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000",
              },
            })}
          />
          <p class="form-error">{errors.HookUMax0?.message}</p>
        </div>
        <div class="form-col1_6">
        <label class="form-label" for="grid-q1k">
            L / U<sub>max,tꝏ</sub>
          </label>
          <input
            class="form-input"
            id="grid-umaxti"
            type="number"
            step={0.1}
            defaultValue={300}
            placeholder="Umax,tꝏ"
            {...register("HookUMax1", {
              required: t("Required"),
              min: {
                value: 10,
                message: t("Minimo") + " 10",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000",
              },
            })}
          />
          <p class="form-error">{errors.HookUMax1?.message}</p>
        </div>
        <div className="form-col1_6"></div>

        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-B">
            {t("MainBeamBaseR")}
          </label>
          <input
            className="form-input"
            id="grid-beam-B"
            type="number"
            step={1}
            placeholder="B [mm]"
            defaultValue={200}
            {...register("HookMainB", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeB(e);
              },
              min: {
                value: 100,
                message: t("Minimo") + " 100",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookMainB?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-H">
            {t("MainBeamHeightR")}
          </label>
          <input
            className="form-input"
            id="grid-beam-H"
            type="number"
            step={1}
            placeholder="H [mm]"
            defaultValue={200}
            {...register("HookMainH", {
              required: t("Required"),
              onChange: (e) => {
                handleChange(e);
              },
              min: {
                value: 100,
                message: t("Minimo") + " 100mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookMainH?.message}</p>
        </div>
        <TimberMaterialPicker ref={TimberMaterialRefMain} />
        <div className="form-col1_6">
          <label className="form-label" for="grid-d">
            {t("InterasseTravi")}
          </label>
          <input
            className="form-input"
            id="grid-d"
            type="number"
            step={0.1}
            defaultValue={600}
            placeholder="i [mm]"
            {...register("HookD", {
              required: t("Required"),
              min: {
                value: 100,
                message: t("Minimo") + " 100",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10000",
              },
            })}
          />
          <p className="form-error">{errors.HookD?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-l">
            {t("LuceTrave")}
          </label>
          <input
            className="form-input"
            id="grid-l"
            type="number"
            step={0.1}
            defaultValue={2000}
            placeholder="L [mm]"
            {...register("HookL", {
              required: t("Required"),
              min: {
                value: 1000,
                message: t("Minimo") + " 1m",
              },
              max: {
                value: 20000,
                message: t("Massimo") + " 20m",
              },
            })}
          />
          <p className="form-error">{errors.HookL?.message}</p>
        </div>
        <div className="form-col1_6"></div>

        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-B">
            {t("SecBeamBaseR")}
          </label>
          <input
            className="form-input"
            id="grid-beam-SecB"
            type="number"
            step={1}
            placeholder="Br [mm]"
            defaultValue={200}
            {...register("HookSecB", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeB(e);
              },
              min: {
                value: 10,
                message: t("Minimo") + " 10",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookSecB?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-beam-SecH">
            {t("SecBeamHeightR")}
          </label>
          <input
            className="form-input"
            id="grid-beam-SecH"
            type="number"
            step={1}
            placeholder="Hr [mm]"
            defaultValue={300}
            {...register("HookSecH", {
              required: t("Required"),
              onChange: (e) => {
                handleChange(e);
              },
              min: {
                value: 10,
                message: t("Minimo") + " 10mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p className="form-error">{errors.HookSecH?.message}</p>
        </div>
        <TimberMaterialPicker ref={TimberMaterialRefSec} />
        <div className="form-col1_6">
          <label className="form-label" for="grid-slab-H">
            {t("Assito")}
          </label>
          <input
            className="form-input"
            id="grid-slab-H"
            type="number"
            step={1}
            placeholder="Ha [mm]"
            defaultValue={0}
            {...register("HookAssito", {
              required: t("Required"),
              onChange: (e) => {
                handleChange(e);
                updateImage(e);
              },
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000",
              },
            })}
          />
          <p className="form-error">{errors.HookAssito?.message}</p>
        </div>
        <div className="form-col1_6"></div>
        <div className="form-col1_6"></div>

        <ScrewPicker ref={ScrewPickerRef} maxL={970} nodeTypeId={7} eta={true} minL={480} startvalue={15} />
        <div className="form-col1_6">
          <label className="form-label" for="grid-Sa">
            {t("ScrewAngle")}
          </label>
          <input
            className="form-input"
            id="grid-Sa"
            type="number"
            step={5}
            defaultValue={45}
            placeholder={t("ScrewAngle")}
            {...register("HookScrewAngle", {
              required: t("Required"),
              min: {
                value: 30,
                message: t("Minimo") + " 30°",
              },
              max: {
                value: 90,
                message: t("Massimo") + " 90°",
              },
            })}
          />
          <p className="form-error">{errors.HookScrewAngle?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-Sc">
            {t("PassoCentrale")}
          </label>
          <input
            className="form-input"
            id="grid-Sc"
            type="number"
            step={0.1}
            defaultValue={300}
            placeholder={t("PassoCentrale")}
            {...register("HookSc", {
              required: t("Required"),
              min: {
                value: 50,
                message: t("Minimo") + " 50",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000",
              },
            })}
          />
          <p className="form-error">{errors.HookSc?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-Sa">
            {t("PassoAppoggio")}
          </label>
          <input
            className="form-input"
            id="grid-Sa"
            type="number"
            step={0.1}
            defaultValue={100}
            placeholder={t("PassoAppoggio")}
            {...register("HookSa", {
              required: t("Required"),
              min: {
                value: 50,
                message: t("Minimo") + " 50",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000",
              },
            })}
          />
          <p className="form-error">{errors.HookSa?.message}</p>
        </div>
        <div className="form-col1_6">
          <label className="form-label" for="grid-Nx">
            {t("ConnectorForSection")}
          </label>
          <input
            className="form-input"
            id="grid-Nx"
            type="number"
            step={1}
            defaultValue={1}
            placeholder={t("ConnectorForSection")}
            {...register("HookNx", {
              required: t("Required"),
              onChange: (e) => {
                updateImage(e);
              },
              min: {
                value: 1,
                message: t("Minimo") + "1",
              },
              max: {
                value: nMax,
                message: t("Massimo") + nMax,
              },
            })}
          />
          <p className="form-error">{errors.HookNx?.message}</p>
        </div>
        <div className="form-col1_6"></div>

        <div className="form-col1_5 py-5 px-3">
          <button name="btn1" className="bg-green-700 text-white font-bold py-2 px-3 rounded" onClick={() => SetCreateReport(0)}>
            {t("Check")}
          </button>
          <button
            name="btn2"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-3 ml-3 rounded align-right"
            onClick={() => SetCreateReport(1)}
          >
            {t("Report")}
          </button>
        </div>
        <div className="form-col1_2 py-5">
          {
            (validData) ? ((Ratio > 1.0) ? (<p className="form-result" hidden={!validData}>{Ratio}</p>): (<p className="form-result-ok" hidden={!validData}>{Ratio}</p>)) : (<div/>)
          }
          {
            (Ratio > 1.0 || !validData) ? (<p className="form-result">{resultMessages}</p>): (<p className="form-result-ok">{resultMessages}</p>)
          }
        </div>
      </div>
    </form>
  );
}
